import { Component, OnInit } from '@angular/core';
import { faStar } from '@fortawesome/pro-duotone-svg-icons';
import { Select, Store } from '@ngxs/store';
import _ from 'lodash';
import { combineLatest, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { UserStatusBrickSettingsStateSelectors } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/user-status-brick-settings/user-status-brick-settings.selectors';
import { SessionState } from 'src/app/store/session/session.state';
import { BasicBrickComponent } from '../../basic-brick-component';

@Component({ template: '' })
export abstract class UserStatusBrickBaseComponent extends BasicBrickComponent implements OnInit {
   brickInstanceId: string;

   public privateLineIcon = faStar;

   @Select(SessionState.getUserFullname)
   public userFullName$: Observable<string>;

   @Select(SessionState.getUserDn)
   public userDn$: Observable<string>;

   @Select(SessionState.getAuthenticatedUserId)
   public userId$: Observable<number>;

   public showBackgroundImage$: Observable<boolean>;
   public showUsername$: Observable<boolean>;
   public showPrivateDn$: Observable<boolean>;
   public showAvatar$: Observable<boolean>;
   public showStatusDropdown$: Observable<boolean>;
   public showAlternativeDeviceEditor$: Observable<boolean>;

   constructor(private store: Store) {
      super();
   }

   ngOnInit() {
      this.showBackgroundImage$ = this.store
         .select(UserStatusBrickSettingsStateSelectors.getIsBackgroundImageShown)
         .pipe(map((fn) => fn(this.brickInstanceId)));

      this.showUsername$ = this.store.select(UserStatusBrickSettingsStateSelectors.getIsUsernameShown).pipe(map((fn) => fn(this.brickInstanceId)));

      this.showPrivateDn$ = combineLatest([this.store.select(UserStatusBrickSettingsStateSelectors.getIsPrivateDnShown), this.userDn$]).pipe(
         switchMap(([fn, userDn]) => of(fn(this.brickInstanceId) && !_.isEmpty(userDn)))
      );

      this.showAvatar$ = this.store.select(UserStatusBrickSettingsStateSelectors.getIsAvatarShown).pipe(map((fn) => fn(this.brickInstanceId)));

      this.showStatusDropdown$ = this.store.select(UserStatusBrickSettingsStateSelectors.getIsStatusDropdownShown).pipe(map((fn) => fn(this.brickInstanceId)));

      this.showAlternativeDeviceEditor$ = this.store
         .select(UserStatusBrickSettingsStateSelectors.getIsAlternativeDeviceEditorShown)
         .pipe(map((fn) => fn(this.brickInstanceId)));
   }
}
